export let StudyContentProgressStatus = /*#__PURE__*/function (StudyContentProgressStatus) {
  StudyContentProgressStatus["TOTAL_COUNT"] = "totalProblemCount";
  StudyContentProgressStatus["GRADED_COUNT"] = "gradedProblemCount";
  StudyContentProgressStatus["COMPLETE_COUNT"] = "completedProblemCount";
  StudyContentProgressStatus["CORRECT_COUNT"] = "correctProblemCount";
  StudyContentProgressStatus["WAIT_COUNT"] = "waitProblemCount";
  StudyContentProgressStatus["WRONG_COUNT"] = "wrongProblemCount";
  StudyContentProgressStatus["CORRECT_RATE"] = "correctRate";
  StudyContentProgressStatus["PROGRESS_RATE"] = "progressRate";
  return StudyContentProgressStatus;
}({});
export let MyContentType = /*#__PURE__*/function (MyContentType) {
  MyContentType["NORMAL_CONTENT"] = "NORMAL_CONTENT";
  MyContentType["WRONG_CONTENT"] = "WRONG_CONTENT";
  return MyContentType;
}({});
export let AssignmentType = /*#__PURE__*/function (AssignmentType) {
  AssignmentType["NORMAL"] = "NORMAL";
  AssignmentType["NORMAL_TEST"] = "NORMAL_TEST";
  AssignmentType["WRONG_TEST"] = "WRONG_TEST";
  AssignmentType["WEEKLY_WRONG_TEST"] = "WEEKLY_WRONG_TEST";
  AssignmentType["LEVEL_TEST"] = "LEVEL_TEST";
  AssignmentType["RETEST"] = "RETEST";
  AssignmentType["REVIEW_TEST"] = "REVIEW_TEST";
  return AssignmentType;
}({});
export const AssignmentTypeLabels = {
  [AssignmentType.NORMAL]: '일반 학습',
  [AssignmentType.NORMAL_TEST]: '일반 테스트',
  [AssignmentType.WRONG_TEST]: '오답 테스트',
  [AssignmentType.WEEKLY_WRONG_TEST]: '주간 오답 테스트',
  [AssignmentType.LEVEL_TEST]: '진단 테스트',
  [AssignmentType.RETEST]: '재시험',
  [AssignmentType.REVIEW_TEST]: '복습 테스트'
};
export const TEST_ASSIGNMENT_TYPES = new Set([AssignmentType.NORMAL_TEST, AssignmentType.WRONG_TEST, AssignmentType.WEEKLY_WRONG_TEST, AssignmentType.LEVEL_TEST, AssignmentType.RETEST, AssignmentType.REVIEW_TEST]);
export let TestFilteringLabel = /*#__PURE__*/function (TestFilteringLabel) {
  TestFilteringLabel["TOTAL"] = "\uC804\uCCB4";
  TestFilteringLabel["SCHOOL_TEST"] = "\uD559\uAD50\uAE30\uCD9C\uBB38\uC81C";
  TestFilteringLabel["MOCK_TEST"] = "\uBAA8\uC758\uACE0\uC0AC";
  TestFilteringLabel["LEVEL_TEST"] = "\uC9C4\uB2E8 \uD14C\uC2A4\uD2B8";
  TestFilteringLabel["CHAPTER_TEST"] = "\uB2E8\uC6D0 \uD14C\uC2A4\uD2B8";
  TestFilteringLabel["TOTAL_TEST"] = "\uCD1D\uAD04 \uD14C\uC2A4\uD2B8";
  TestFilteringLabel["DAILY_TEST"] = "\uB370\uC77C\uB9AC \uD14C\uC2A4\uD2B8";
  TestFilteringLabel["REVIEW_TEST"] = "\uBCF5\uC2B5 \uD14C\uC2A4\uD2B8";
  TestFilteringLabel["WRONG_TEST"] = "\uC624\uB2F5 \uD14C\uC2A4\uD2B8";
  TestFilteringLabel["WEEKLY_WRONG_TEST"] = "\uC8FC\uAC04 \uC624\uB2F5 \uD14C\uC2A4\uD2B8";
  return TestFilteringLabel;
}({});
export let ReviewPageExtractionType = /*#__PURE__*/function (ReviewPageExtractionType) {
  ReviewPageExtractionType["FIRST_SOLVING_WRONG"] = "FIRST_SOLVING_WRONG";
  ReviewPageExtractionType["BOOKMARKED_BY_TEACHER"] = "BOOKMARKED_BY_TEACHER";
  ReviewPageExtractionType["BY_MASTERY_LEVEL"] = "BY_MASTERY_LEVEL";
  ReviewPageExtractionType["RUBRIC_GRADE_WRONG"] = "RUBRIC_GRADE_WRONG";
  ReviewPageExtractionType["MANUAL_SELECTION"] = "MANUAL_SELECTION";
  return ReviewPageExtractionType;
}({});
export let GradingResult = /*#__PURE__*/function (GradingResult) {
  GradingResult["CORRECT"] = "CORRECT";
  GradingResult["WRONG"] = "WRONG";
  return GradingResult;
}({});
export let RubricTraitGradingResult = /*#__PURE__*/function (RubricTraitGradingResult) {
  RubricTraitGradingResult["CORRECT"] = "CORRECT";
  RubricTraitGradingResult["WRONG"] = "WRONG";
  return RubricTraitGradingResult;
}({});
export let RubricOverallGradingResult = /*#__PURE__*/function (RubricOverallGradingResult) {
  RubricOverallGradingResult["CORRECT"] = "CORRECT";
  RubricOverallGradingResult["WRONG"] = "WRONG";
  RubricOverallGradingResult["NONE"] = "NONE";
  RubricOverallGradingResult["PENDING"] = "PENDING";
  return RubricOverallGradingResult;
}({});
export let AnswerEntryGradingResult = /*#__PURE__*/function (AnswerEntryGradingResult) {
  AnswerEntryGradingResult["CORRECT"] = "CORRECT";
  AnswerEntryGradingResult["INCORRECT"] = "INCORRECT";
  AnswerEntryGradingResult["PENDING"] = "PENDING";
  return AnswerEntryGradingResult;
}({});
export let FeedbackCheckStatus = /*#__PURE__*/function (FeedbackCheckStatus) {
  FeedbackCheckStatus["COMPLETE"] = "COMPLETE";
  FeedbackCheckStatus["PENDING"] = "PENDING";
  FeedbackCheckStatus["NONE"] = "NONE";
  return FeedbackCheckStatus;
}({});
export let ErrorReportType = /*#__PURE__*/function (ErrorReportType) {
  ErrorReportType["LECTURE_NOT_UNDERSTAND"] = "lecture-not-understand";
  ErrorReportType["PROBLEM_REPORT"] = "problem-report";
  return ErrorReportType;
}({});
export let ClassificationType = /*#__PURE__*/function (ClassificationType) {
  ClassificationType["CHAPTER"] = "chapter";
  ClassificationType["SECTION"] = "section";
  ClassificationType["SUBSECTION"] = "subsection";
  ClassificationType["PROBLEM_TYPE"] = "problemType";
  ClassificationType["INDEX"] = "index";
  ClassificationType["MATERIAL"] = "material";
  return ClassificationType;
}({});
export let ProblemStatusModalType = /*#__PURE__*/function (ProblemStatusModalType) {
  ProblemStatusModalType["MATERIAL"] = "material";
  ProblemStatusModalType["STUDENT_ANSWER"] = "studentAnswer";
  return ProblemStatusModalType;
}({});
export let AnomalyType = /*#__PURE__*/function (AnomalyType) {
  AnomalyType["SHORT_SOLVING_TIME"] = "SHORT_SOLVING_TIME";
  AnomalyType["LONG_SOLVING_TIME"] = "LONG_SOLVING_TIME";
  AnomalyType["REVIEW_NOTE_CORRECT_AFTER_SHORT_TAKING_LECTURE"] = "REVIEW_NOTE_CORRECT_AFTER_SHORT_TAKING_LECTURE";
  AnomalyType["NO_RELEVANT_AUDIO_IN_DESCRIPTION_VIDEO"] = "NO_RELEVANT_AUDIO_IN_DESCRIPTION_VIDEO";
  return AnomalyType;
}({});
export let AnomalyStatus = /*#__PURE__*/function (AnomalyStatus) {
  AnomalyStatus["DETECTED"] = "DETECTED";
  AnomalyStatus["RESOLVED"] = "RESOLVED";
  return AnomalyStatus;
}({});